import styled from "styled-components";

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 60px;
  margin: 60px auto 20px;
`;

export default ButtonsWrapper;
